import { createContext, useContext, useState, useEffect } from 'react'

const ThemeContext = createContext(null)

export function ThemeProvider({ children }) {
  const [dark, setDark] = useState(() => localStorage.getItem('theme') === 'dark')

  useEffect(() => {
    localStorage.setItem('theme', dark ? 'dark' : 'light')
  }, [dark])

  const toggle = () => setDark(d => !d)

  const t = dark ? {
    dark: true,
    bg:          '#0F172A',
    surface:     '#1E293B',
    card:        '#1E293B',
    cardBorder:  '#334155',
    sidebar:     '#0F172A',
    sidebarBorder: '#1E293B',
    text:        '#F1F5F9',
    textSub:     '#94A3B8',
    textMuted:   '#64748B',
    border:      '#334155',
    input:       '#0F172A',
    inputBorder: '#334155',
    inputText:   '#F1F5F9',
    hover:       '#334155',
    navHover:    'rgba(245,158,11,0.15)',
    amber:       '#F59E0B',
    green:       '#059669',
    greenSoft:   '#064E3B',
    red:         '#DC2626',
    redSoft:     '#450A0A',
    blue:        '#3B82F6',
    blueSoft:    '#1E3A5F',
    purple:      '#7C3AED',
  } : {
    dark: false,
    bg:          '#F1F5F9',
    surface:     '#F8FAFC',
    card:        '#FFFFFF',
    cardBorder:  '#E2E8F0',
    sidebar:     '#1E293B',
    sidebarBorder: '#334155',
    text:        '#0F172A',
    textSub:     '#475569',
    textMuted:   '#64748B',
    border:      '#E2E8F0',
    input:       '#FFFFFF',
    inputBorder: '#E2E8F0',
    inputText:   '#0F172A',
    hover:       '#F1F5F9',
    navHover:    'rgba(245,158,11,0.2)',
    amber:       '#F59E0B',
    green:       '#059669',
    greenSoft:   '#ECFDF5',
    red:         '#DC2626',
    redSoft:     '#FEF2F2',
    blue:        '#3B82F6',
    blueSoft:    '#EFF6FF',
    purple:      '#7C3AED',
  }

  return (
    <ThemeContext.Provider value={{ dark, toggle, t }}>
      {children}
    </ThemeContext.Provider>
  )
}

export const useTheme = () => useContext(ThemeContext)